import { usePreviewStore } from "../../stores/previewStore.js";
import { Button } from "../ui/Button.js";

export function PreviewToolbar({ onHide }: { onHide?: () => void }) {
  const currentPage = usePreviewStore((state) => state.currentPage);
  const totalPages = usePreviewStore((state) => state.totalPages);
  const isGenerating = usePreviewStore((state) => state.isGenerating);

  return (
    <div style={{ height: 44, display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0 12px", borderBottom: "1px solid #e2e8f0", background: "#fff" }}>
      <div style={{ fontSize: 13, fontWeight: 800, color: "#334155" }}>PDFプレビュー</div>
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        {onHide && <Button onClick={onHide} style={{ padding: "4px 8px", minHeight: 28 }}>非表示</Button>}
        <Button disabled style={{ padding: "4px 8px", minHeight: 28 }}>‹</Button>
        <span style={{ fontSize: 12, color: "#64748b", minWidth: 34, textAlign: "center" }}>{currentPage}/{totalPages}</span>
        <Button disabled style={{ padding: "4px 8px", minHeight: 28 }}>›</Button>
        {isGenerating && <span style={{ color: "#0f766e", fontSize: 12, fontWeight: 700 }}>生成中</span>}
      </div>
    </div>
  );
}
